<template>
  <div>
    <van-nav-bar title="装箱单预录" left-text="返回" left-arrow @click-left="onClickLeft"/>
    <van-form @submit="onSubmit">
      <van-field name="uploader" label="装箱单上传">
        <template #input>
          <van-uploader v-model="uploader" :after-read="afterRead" max-count="5" multiple/>
        </template>
      </van-field>
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">提交</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import Vue from 'vue';
import {Dialog, Form} from 'vant';
import axios from 'axios';
import common from "../../common";

Vue.use(Form);

export default {
  data() {
    return {
      name: '',
      mobile: '',
      uploader: [],
    };
  },
  methods: {
    onClickLeft() {
      this.$router.push({path: "/pre-record/home"});
    },

    afterRead(file) {
      let formData = new FormData();
      if(file instanceof Array&&file.length){//多图
        for (let i = 0; i < file.length; i++) {
          const element = file[i].file;
          formData.append(["file"+'['+[i]+']'],element);//添加
        }
      }else{//单张
        formData.append(["file"+'['+[0]+']'],file.file);
      }
      axios({
        method: 'post',
        url: 'https://oil-api.baiduwebs.top/wx/prerecord/input',
        data: formData
      }).then(res => {
        if(res.status==200){
          let total=this.picture_list.length+res.data.data.length;
          if(total>5){//处理图片最多可上传5张
            let Length=(res.data.data.length+this.picture_list.length)-5;
            let num=res.data.data.length-Length;
            let arrImg=res.data.data.splice(0,num);
            this.picture_list.push(...arrImg);
          }else{
            this.picture_list.push(...res.data.data);
          }
        }
      }).catch((err) => {
        console.log(err);
      })
    },
    onSubmit(values) {
      let querystring = require("querystring");
      this.$api.post("wx/prerecord/input",
          querystring.stringify({
            mobile: localStorage.getItem("mobile"),
            name: localStorage.getItem("name"),
            uploader: localStorage.getItem("uploader"),
          })
      ).then(({data}) => {
        if (data.status == 1) {
          Dialog.alert({
            message: data.msg,
          }).then(() => {
            this.$router.push({path: "/pre-record/home"});
          });
        } else {
          Dialog.alert({
            message: data.msg,
          }).then(() => {
          });
        }
      });
    },
    //获取用户openid
    getOpenid() {
      let url = window.location.href;
      let querystring = require("querystring");
      this.$api.post("/wx/getUrl",
          querystring.stringify({
            url
          })
      ).then(({data}) => {
        window.location.href = data;
      });
    },
  },
  mounted() {
    //判断cookie中是否存在token
    let ifcookietoken = document.cookie.indexOf("token=") != -1;
    //判断地址栏上是否存在openid;
    let ifopenid = window.location.href.indexOf("openid") != -1;
    //判断是否已经登录
    if (!!JSON.parse(common.getlocalStorage("userInfo"))) {
      this.mobile = JSON.parse(common.getlocalStorage("userInfo")).mobile;
      this.login_bol = true;
      let token = JSON.parse(common.getlocalStorage("userInfo")).token;
    } else if (ifcookietoken) {
      this.login_bol = true;
      let token = common.getCookie("token");
      this.mobile = common.getCookie("mobile");
    } else if (ifopenid) {
      let openid = window.location.href.split("openid=")[1].split("#/")[0];
      this.ifQueryBinding(openid);
    } else {
      this.getOpenid();
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/pre-record/input.vue